import { Link } from 'react-router-dom';

import { Logo } from '@/components/ui/Logo';

const col = { display: 'flex', flexDirection: 'column', gap: 10 } as const;
const colHead = {
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: 0.08,
  color: 'var(--ink-3)',
  fontFamily: 'var(--font-mono)',
} as const;
const link = { fontSize: 13, color: 'var(--ink-2)', textDecoration: 'none' } as const;

export function MarketingFooter() {
  return (
    <footer style={{ borderTop: '1px solid var(--line)', background: 'var(--paper-2)', marginTop: 80 }}>
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '60px 24px 40px',
          display: 'grid',
          gridTemplateColumns: '2fr repeat(4, 1fr)',
          gap: 40,
        }}
      >
        <div style={col}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Logo size={24} />
            <span style={{ fontWeight: 600, fontSize: 16 }}>Emailforge</span>
          </div>
          <p style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.5, maxWidth: 320 }}>
            Emails that render everywhere. React Email + Handlebars, your SMTP, export to{' '}
            <span className="mono">.tsx</span> whenever you want.
          </p>
          <div
            className="mono"
            style={{ fontSize: 10.5, color: 'var(--ink-3)', letterSpacing: 0.04, textTransform: 'uppercase' }}
          >
            Part of the Contra Products suite
          </div>
        </div>

        <div style={col}>
          <div style={colHead}>Product</div>
          <Link to="/" style={link}>Features</Link>
          <Link to="/pricing" style={link}>Pricing</Link>
          <Link to="/export-pack" style={link}>Export Pack</Link>
          <Link to="/changelog" style={link}>Changelog</Link>
        </div>

        <div style={col}>
          <div style={colHead}>Developers</div>
          <Link to="/docs" style={link}>Docs</Link>
          <a href="/api/docs" style={link} target="_blank" rel="noopener noreferrer">
            API reference
          </a>
          <Link to="/status" style={link}>Status</Link>
        </div>

        <div style={col}>
          <div style={colHead}>Company</div>
          <Link to="/about" style={link}>About</Link>
          <Link to="/blog" style={link}>Blog</Link>
          <Link to="/careers" style={link}>Careers</Link>
          <Link to="/contact" style={link}>Contact</Link>
        </div>

        <div style={col}>
          <div style={colHead}>Legal</div>
          <Link to="/privacy" style={link}>Privacy</Link>
          <Link to="/terms" style={link}>Terms</Link>
          <Link to="/dpa" style={link}>DPA</Link>
        </div>
      </div>

      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '20px 24px',
          borderTop: '1px solid var(--line-soft)',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          fontSize: 12,
          color: 'var(--ink-3)',
        }}
      >
        <span>© {new Date().getFullYear()} Contra Products</span>
        <span style={{ flex: 1 }} />
        <span className="mono" style={{ fontSize: 10.5, letterSpacing: 0.04 }}>
          built with Emailforge · dogfooded
        </span>
      </div>
    </footer>
  );
}
